import { Spinner } from '@frontend/components/common';
import { Keyboard, QRCode } from '@frontend/icons';
import { FormattedMessage, useIntl } from 'react-intl';

import { MethodButton } from '../../components/method-button/method-button';
import { MethodOrDivider } from '../../components/method-or-divider.component';
import { TransactionCard } from '../../components/transaction-card';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useAuthenticatedPickUpMethod from './authenticated-pick-up-method.controller';

const ID = 'authenticated-pick-up-method';

const AuthenticatedPickUpMethod = () => {
    const intl = useIntl();
    const viewProps = useAuthenticatedPickUpMethod();

    const transactionsIncluded = viewProps.userTransactions && viewProps.userTransactions.length > 0;
    const transactionsEmpty = viewProps.userTransactions !== null && viewProps.userTransactions.length === 0;

    return (
        <WizardScreenContainer
            id={ID}
            containerClassName='flex size-full flex-col gap-3 overflow-x-hidden overflow-y-auto p-6'>
            <div className='text-always-black w-full shrink-0 text-base font-medium'>
                {transactionsIncluded ? (
                    <FormattedMessage
                        id='kiosk.wizard.authenticated-pick-drop-method.instructions'
                        description='Instructions for authenticated pick and drop method screen'
                        defaultMessage='Choose a transaction to continue'
                    />
                ) : transactionsEmpty ? (
                    <FormattedMessage
                        id='kiosk.wizard.authenticated-pick-up-method.no-receiver-transactions'
                        description='Message shown when the logged-in user has no pick-up transactions as receiver'
                        defaultMessage='You do not have any transactions that you are a receiver of.'
                    />
                ) : (
                    <FormattedMessage
                        id='kiosk.wizard.pick-up-method.instructions'
                        description='Instructions for pick-up method selection'
                        defaultMessage='Please choose one of the options to continue your pick-up'
                    />
                )}
            </div>

            {viewProps.userTransactions === null && (
                <div className='flex flex-col items-start justify-center gap-2 self-stretch'>
                    <div className='bg-background-surface flex h-36 w-full animate-pulse items-center justify-center rounded-xl'>
                        <Spinner className='text-border-default fill-brand-primary size-8' />
                    </div>
                </div>
            )}

            {transactionsIncluded && (
                <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                    {viewProps.userTransactions?.map((transaction) => (
                        <TransactionCard
                            key={transaction.id}
                            transaction={transaction}
                            onClick={() => viewProps.onTransactionContinue(transaction)}
                            isLoading={viewProps.transactionDataLoading?.id === transaction.id}
                            isDisabled={!!viewProps.transactionDataLoading}
                            showShippingNotes={viewProps.isNivaliz}
                        />
                    ))}
                </div>
            )}

            <div className='mt-auto flex flex-col items-start justify-start gap-2 self-stretch'>
                <MethodOrDivider />
                {viewProps.pinStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Input PIN-code',
                            id: 'kiosk.wizard.drop-off-method.input-pin',
                            description: 'Label for button to input PIN-code manually'
                        })}
                        icon={<Keyboard className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.pinStep)}
                    />
                )}
                {viewProps.scanStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Scan QR-code',
                            id: 'kiosk.wizard.drop-off-method.scan-qr',
                            description: 'Label for button to scan QR code'
                        })}
                        icon={<QRCode className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.scanStep)}
                    />
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default AuthenticatedPickUpMethod;
